export const prevArrow = `
    <button aria-label="Previous slide" class="slider__arrow slider__prev slick-prev button">
        ${Nu.arrows.left}
    </button>`;
export const nextArrow = `
    <button aria-label="Next slide" class="slider__arrow slider__next slick-next button">
      ${Nu.arrows.right}
    </button>`;

export const options = {
    slidesToShow: 3,
    swipeToSlide: true,
    infinite: false,
    cssEase: "ease",
    speed: 300,
    nextArrow,
    prevArrow,
};
